export default __webpack_public_path__ + "images/4c1cca630df4ba1b6b259262eb6b18b7.png";